import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import UseAxiosPublic from '../hooks/UseAxiosPublic';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    // 1. Initialize react-hook-form methods
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [previewImage,setPreviewImage]=useState(null);
    const axiosPublic=UseAxiosPublic();
    const navigate=useNavigate();

   const fetchProfileImage = async (email) => {
    if (!email) return;

    try {
        const res = await axiosPublic.get(`/user/${email}`);
        setPreviewImage(res.data.profileImage);
    } catch (error) {
        console.error(error);
    }
};



   


    const onSubmit = async (data) => {
        // TODO: Wire up your login logic here (e.g., using loginUser from UseAuth)
        console.log("Login Form Data:", data);
        try{
            const res=await axiosPublic.post("/login",data);
            console.log(res.data);
            if(res.data.success){
                navigate('/dashboard');
            }
        }catch(error){
            console.error("Error during login:",error);
        }

     
    };

    return (
        <div className="min-h-screen bg-slate-950 flex flex-col justify-center items-center p-4 antialiased">
            <div className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-3xl p-6 shadow-2xl space-y-6">

                <div className="text-center space-y-2">
                    <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-transparent">
                        Welcome Back
                    </h1>
                    <p className="text-sm text-slate-400">Sign in to your account</p>
                    <div className="flex justify-center items-center mt-4 rounded-full">
                        {
                            previewImage && (
                                <img src={previewImage} alt="Profile Preview" className="w-20 h-20 rounded-full mx-auto mb-2" />
                            )
                        }
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    
                    {/* Email Field */}
                    <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-slate-300 tracking-wide uppercase px-1">Email Address</label>
                        <input
                            type="email"
                            placeholder="you@example.com"
                            className={`w-full bg-slate-950 border text-slate-100 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:ring-2 transition-all ${
                                errors.email 
                                    ? 'border-rose-500/50 focus:ring-rose-500/20 focus:border-rose-500' 
                                    : 'border-slate-800 focus:ring-indigo-500/20 focus:border-indigo-500'
                            }`}
                            {...register('email', {
                                required: 'Email is required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Invalid email address'
                                },
                                onChange: (e) => fetchProfileImage(e.target.value) // Fetch profile image on email change

                            })}
                        />
                        {errors.email && <p className="text-xs text-rose-400 px-1">{errors.email.message}</p>}
                    </div>

                    {/* Password Field */}
                    <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-slate-300 tracking-wide uppercase px-1">Password</label>
                        <input
                            type="password"
                            placeholder="••••••••"
                            className={`w-full bg-slate-950 border text-slate-100 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:ring-2 transition-all ${
                                errors.password 
                                    ? 'border-rose-500/50 focus:ring-rose-500/20 focus:border-rose-500' 
                                    : 'border-slate-800 focus:ring-indigo-500/20 focus:border-indigo-500'
                            }`}
                            {...register('password', {
                                required: 'Password is required'
                            })}
                        />
                        {errors.password && <p className="text-xs text-rose-400 px-1">{errors.password.message}</p>}
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full mt-2 bg-gradient-to-r from-indigo-500 to-violet-600 hover:from-indigo-600 hover:to-violet-700 text-white font-medium rounded-xl py-3.5 text-sm shadow-lg shadow-indigo-500/20 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 active:scale-[0.98] transition-all"
                    >
                        Sign In
                    </button>
                </form>

                <div className="text-center pt-2">
                    <p className="text-xs text-slate-400">
                        Don't have an account?{' '}
                        <a href="/signup" className="text-indigo-400 hover:text-indigo-300 font-medium transition-colors">Sign Up</a>
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Login;